import withSectionPanel from './with-section-panel';

export default withSectionPanel;